/** Instructor chips — avatar + name, wrapped in a labelled list. Presentational only. */

import { Avatar } from '@butter/ui/primitives/data-display';
import type { LessonInstructorRef } from '~/services/internalApi/lessons';

export interface LessonInstructorChipsProps {
  instructors: readonly LessonInstructorRef[];
  'aria-labelledby'?: string;
  'data-testid'?: string;
}

export function LessonInstructorChips({ instructors, 'aria-labelledby': labelledBy, 'data-testid': testId }: LessonInstructorChipsProps) {
  return (
    <ul aria-labelledby={labelledBy} data-testid={testId} className="flex flex-wrap gap-2.5">
      {instructors.map(({ id, firstName, lastName, image }) => {
        const name = `${firstName} ${lastName}`;
        return (
          <li key={id} data-testid={`lesson-instructor-chip-${id}`} className="flex items-center gap-1.5 rounded-full border border-butter-gray-200 py-1 pl-1 pr-3">
            <span aria-hidden="true" className="flex size-7 shrink-0 overflow-hidden rounded-full border border-butter-gray-100">
              <Avatar name={name} src={image?.url} alt={image?.alt} size="sm" className="size-full" />
            </span>
            <span className="text-sm font-medium text-butter-gray-700">{name}</span>
          </li>
        );
      })}
    </ul>
  );
}
